import { render, staticRenderFns } from "./ParticipantsAvatars.vue?vue&type=template&id=1ea6c4aa"
import script from "./ParticipantsAvatars.vue?vue&type=script&lang=js"
export * from "./ParticipantsAvatars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Avatar.vue').default})
